// import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { useState } from 'react';
import { sendEmailVerification } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../contexts/authentication';

export default function AlertVerifyEmail() {
  const currentUser = auth.currentUser;
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const navigate = useNavigate();

  const handleClick = async () => {
    if (currentUser) {
      await sendEmailVerification(currentUser, {
        url: `${baseUrl}/verify-email`,
      });
      alert(`Email de autenticação enviado para: ${currentUser.email}`);
    } else {
      alert('Usuário não autenticado. Faça o login.');
      navigate('/signin');
    }
  }

  return (
    <Card variant="outlined" sx={{ m: 1.5, flexShrink: 0 }}>
      <CardContent>
        <WarningRoundedIcon fontSize="small" sx={{ color: '#f9bd00' }} />
        <Typography gutterBottom sx={{ fontWeight: 600 }}>
          Atenção!
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Seu email ainda não foi verificado. <br /><br /> Não recebeu seu email de verificação?
        </Typography>
        <Button variant="contained" size="small" fullWidth onClick={handleClick}>
          Reenviar email
        </Button>
      </CardContent>
    </Card>
  );
}